import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Card from '@mui/material/Card';
import { Box, CardContent, Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { lowStockReport } from '../../../controllers/settings/inventoryControllers';
import InputForm from '../../../components/forms/InputForm';
import ScreenWrapper from '../../../components/wrappers/ScreenWrapper';
import { queryStatusWithLength } from '../../../shared/utils/queryUtils';
import { colors } from '../../../assets/styles/colors';
import {
  TableRowStyled,
  TbRowHeaderStyled,
} from '../../../components/styled/TableRowStyled';
import {
  TbCellAmount,
  TbCellBody,
  TbCellHeader,
  TbCellSummary,
} from '../../../components/styled/TableCellStyled';

const init = { initialData: [] };

function LowStockReport() {
  const { t } = useTranslation();
  const [filteredItems, setFilteredItems] = useState<any>([]);
  const [searchText, setSearchText] = useState<string>('');

  const reportQuery = useQuery(['lowStockReport'], lowStockReport, init);
  const { data = [] } = reportQuery;

  const onSearch = (inputText: string) => {
    const text = inputText.toLowerCase();
    setSearchText(inputText);

    const filtered = data.filter((product: any) => {
      const { name, currentStock, minStockQuantity } = product;

      const hasName = name?.toLowerCase().includes(text);
      const hasCurrentStk = String(currentStock)?.toLowerCase().includes(text);
      const hasMin = String(minStockQuantity)?.toLowerCase().includes(text);

      if (hasName || hasCurrentStk || hasMin) {
        return true;
      }
    });
    setFilteredItems(filtered);
  };

  let productList = data;
  if (searchText) {
    productList = filteredItems;
  }

  // console.log('productList', productList);

  return (
    <ScreenWrapper {...queryStatusWithLength([reportQuery])}>
      <Card sx={{ paddingX: 4 }}>
        <CardContent sx={{ paddingY: 1 }}>
          <Stack pb={1} direction={'row'} alignItems={'center'}>
            <Typography flex={3} sx={{ fontSize: 20 }}>
              {t('reportStack.lowStock')} ({productList.length})
            </Typography>
            <Stack pb={0.6} flex={1}>
              <InputForm
                size="small"
                inLineLabel={true}
                label={'Search Product...'}
                onChangeText={(v: string) => onSearch(String(v))}
              />
            </Stack>
          </Stack>

          <Divider />

          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TbRowHeaderStyled>
                  <TbCellHeader sx={{ maxWidth: 20 }}>SN</TbCellHeader>
                  <TbCellHeader>Product Name</TbCellHeader>
                  <TbCellHeader align="right">Minimum Stock</TbCellHeader>
                  <TbCellHeader align="right">Current Stock</TbCellHeader>
                </TbRowHeaderStyled>
              </TableHead>
              <TableBody>
                {productList.map((row, index) => (
                  <TableRowStyled key={row.id}>
                    <TbCellBody sx={{ maxWidth: 20 }}>{index + 1}</TbCellBody>
                    <TbCellBody>{row.name}</TbCellBody>
                    <TbCellAmount>{row.minStockQuantity}</TbCellAmount>
                    <TbCellSummary sx={{ color: colors.theme2 }}>
                      {row.currentStock} {row.primaryUnit?.name}
                    </TbCellSummary>
                  </TableRowStyled>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </ScreenWrapper>
  );
}

export default LowStockReport;
